import { Component,OnDestroy, ViewChild,Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router,  ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { QueryStringParameter, DynamicPage} from '../../models/data.types';
import { DynamicPageComponent } from '../../helpers/dynamicPage';
import { DynamicPageDirective } from '../../directives/index';


@Component({
  entryComponents: [DynamicPageComponent],
  templateUrl: './page.component.html'
})
export class PageComponent {
  
  sub: any;
  pagename: string;
  page: DynamicPage = new DynamicPage();

  @ViewChild(DynamicPageDirective) dynamicPage: DynamicPageDirective;

  constructor( private renderer: Renderer2,private route: ActivatedRoute,private apiService : ApiService,private titleService: Title) { }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {

          this.pagename = params['id'];
     
        let dynamicPageComponent = new DynamicPageComponent(this.route,this.apiService,this.titleService);
        dynamicPageComponent.LoadDynamicPage(this.pagename,this.dynamicPage,true);

    });

  }

}



// WEBPACK FOOTER //
// ./src/app/views/page/page.component.ts